<template>
  <v-row>
    <v-col cols="12">
      <h3 class="mt-0 text-h3" v-if="$vuetify.breakpoint.mdAndUp">{{ $t('cpp-text-2') }}</h3>
      <span>{{ $t('cpp-text-3') }}</span>
    </v-col>
    <v-col cols="12" v-if="$vuetify.breakpoint.smAndDown">
        <p class="ok-title">{{ $t('debtOpenAmount') }}</p>
        <span class="ok-subtitle mr-3">{{ maxPaymentAmount | currency }}</span>
    </v-col>
    <v-col cols="8" md="3">
      <p class="ok-title mb-3">{{ $t('cpp-text-1') }}</p>
      <v-text-field v-model="amount"
                    type="number"
                    min="5"
                    :max="debt.debtSummary.left"
                    step="any"
                    append-icon="fas fa-euro-sign"
                    @blur="$v.amount.$touch()"
                    :error-messages="amountErrors"
                    outlined
                    dense
                    class="text-center"></v-text-field>
    </v-col>
    <v-col cols="12" md="9" v-if="!isCompany">
      <p class="ok-title mb-3">{{ $t('dueDate') }}</p>
      <v-radio-group v-model="desiredDueDate" hide-details row>
        <v-radio class="ok-title" color="color-new-link-blue" :label="$t('firstOfMonth')" value="0"></v-radio>
        <v-radio class="ok-title" color="color-new-link-blue" :label="$t('middleOfMonth')" value="1"></v-radio>
        <v-radio class="ok-title" color="color-new-link-blue" :label="$t('lastOfMonth')" value="2"></v-radio>
      </v-radio-group>
    </v-col>
    <v-col cols="12" v-if="hasBanditRating3">
      <v-row align="center">
        <v-col class="shrink">
          <v-icon class="warning--text">fas fa-info-circle</v-icon>
        </v-col>
        <v-col>
          <span class="font-weight-bold">{{ $t('cpp-text-4') }}</span>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" :class="{ 'text-center': $vuetify.breakpoint.smAndDown }">
      <shared-calculate-payment-plan-button :debts="[debt]" :amount="amount" :desiredDueDate="desiredDueDate" @minAmount="setMinAmount" class="mb-4"></shared-calculate-payment-plan-button>
    </v-col>
  </v-row>
</template>

<script>
  import { required, numeric, between } from 'vuelidate/lib/validators'

  export default {
    props: ['debt'],
    data: function () {
      return {
        amount: null,
        desiredDueDate: '0',
        confirmationDialog: false,
        planType: 0,
        minAmount: 0
      }
    },
    methods: {
      setMinAmount: function (minAmount) {
        this.minAmount = minAmount
      },
      tabChange (tabIndex) {
        this.planType = tabIndex
      }
    },
    computed: {
      paymentPlanRequest () {
        return {
          debtNrs: [this.debt.nr],
          type: this.planType,
          amount: this.amount,
          date: parseInt(this.desiredDueDate, 10)
        }
      },
      isCompany () {
        return this.$store.getters.isCompany
      },
      amountErrors () {
        const errors = []
        if (!this.$v.amount.$dirty) return errors
        !this.$v.amount.between && errors.push(this.$t('validation.amount.between') + ' ' + this.minPaymentAmount + ' € - ' + Math.floor(this.maxPaymentAmount) + ' €')
        !this.$v.amount.required && errors.push(this.$t('validation.amount.required'))
        return errors
      },
      minPaymentAmount () {
        return this.minAmount
      },
      maxPaymentAmount () {
        return this.debt.debtSummary.left
      },
      maxLength () {
        return this.debt.paymentPlanParameters.maximumLengthInMonths
      },
      hasBanditRating3() {
        return this.debt.banditRating === 3
      }
    },
    validations: {
      amount: {
        required,
        numeric,
        between (value) {
          return between(this.minPaymentAmount, this.maxPaymentAmount)(value)
        }
      }
    }
  }
</script>

<i18n>
  {
  "fi": {
  "cpp-text-1": "Syötä kuukausierä",
  "cpp-text-2": "Tee maksusuunnitelma",
  "cpp-text-3": "Aloita velan lyhentäminen valitsemalla sinulle sopivin maksuerä ja eräpäivä.",
  "cpp-text-4": "Vahvistaaksesi maksusuunnitelman sinun tulee maksaa ensimmäinen erä tänään. Seuraava maksu erääntyy yllä valitsemasi aikataulun mukaisesti."
  },
  "se": {
  "cpp-text-1": "Välj månadsrat",
  "cpp-text-2": "Gör betalningsplan",
  "cpp-text-3": "Börja amorteringen genom att välja en lämplig summa.",
  "cpp-text-4": "För att bekräfta betalningsplanen måste du betala den första delbetalningen idag. Nästa betalning förfaller enligt det schema du valt ovan."
  },
  "en": {
  "cpp-text-1": "Set monthly amount",
  "cpp-text-2": "Create payment plan",
  "cpp-text-3": "Start creating the payment plan by choosing an amount and due date that suits you the best.",
  "cpp-text-4": "To confirm the payment plan, you must pay the first instalment today. The next payment is due according to the schedule you select above."
  }
  }
</i18n>
